module.exports = __webpack_public_path__ + "images/emoji/cn.64d25bfe10f422e5d718.png";